"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowCard = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var FlowCardStep_1 = require("./FlowCardStep");
var FlowCard = function (_a) {
    var _b = _a.currentIndex, currentIndex = _b === void 0 ? undefined : _b, ordered = _a.ordered, className = _a.className, props = __rest(_a, ["currentIndex", "ordered", "className"]);
    var children = props.children, rest = __rest(props, ["children"]);
    var childrenArray = Array.isArray(children) ? children : [children];
    var renderChildren = childrenArray.map(function (child, index) {
        var hasIndex = currentIndex !== false;
        return react_1.default.cloneElement(child, {
            active: hasIndex && index === currentIndex,
            key: index,
            orderNumber: ordered && !child.props.orderNumber
                ? index + 1
                : child.props.orderNumber,
        });
    });
    return (react_1.default.createElement("div", __assign({ className: classnames_1.default('FlowCard', className) }, rest), renderChildren));
};
exports.FlowCard = FlowCard;
exports.FlowCard.Step = FlowCardStep_1.FlowCardStep;
//# sourceMappingURL=FlowCard.js.map